import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7629112e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full p-11" }
const _hoisted_2 = { class: "text-base font-bold" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 加入或创建团队 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_5 = { class: "flex justify-center mt-12" }
const _hoisted_6 = { class: "flex justify-center mt-14" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f7b500"} }, "加入"),
    /*#__PURE__*/_createTextVNode("团队")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex mt-8 mb-7" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " 你的团队已经在使用谈信，可通过扫描团队二维码进入团队，与成员一起沟通协作，高效作业。 ")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#eb8282"} }, "创建"),
    /*#__PURE__*/_createTextVNode("团队")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex mt-8 mb-7" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " 通过创建团队，你将直接成为团队或企业负责人，可添加成员，让整个团队一起享受高效的沟通协作吧。 ")
  ])
], -1))

import { useAccount } from '@/composables/user/useAccount'
import { Dialog } from 'quasar'

import CreateDialogVue from './enterprise/CreateDialog.vue'
import JoinDialogVue from './enterprise/JoinDialog.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { logout } = useAccount()

function openCreateDialog() {
    Dialog.create({ component: CreateDialogVue })
}

function openJoinDialog() {
    Dialog.create({ component: JoinDialogVue })
}

return (_ctx: any,_cache: any) => {
  const _component_base_btn = _resolveComponent("base-btn")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_base_btn, {
        onClick: _unref(logout),
        flat: "",
        class: "float-right"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_img, {
        src: require('images/enterprise-null.png'),
        width: "427px"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        onClick: openJoinDialog,
        class: "shadow w-72 mr-4 px-4 py-5 cursor-pointer flex items-center"
      }, [
        _hoisted_7,
        _createVNode(_component_q_icon, {
          name: "more_vert",
          color: "subtle",
          size: "22px"
        })
      ]),
      _createElementVNode("div", {
        onClick: openCreateDialog,
        class: "shadow w-72 mr-4 px-4 py-5 cursor-pointer flex items-center"
      }, [
        _hoisted_8,
        _createVNode(_component_q_icon, {
          name: "more_vert",
          color: "subtle",
          size: "22px"
        })
      ])
    ])
  ]))
}
}

})